// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flipkart-filter-section {
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 8px; /* Reduced margin */
    width: 280px; /* Increased width */
  }
  
  .filter-section-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 0; /* Reduced padding */
    font-weight: 500;
    font-size: 14px;
    color: #212121;
    cursor: pointer;
  }
  
  .filter-section-content {
    padding: 0;
  }
  
  .filter-search-box {
    margin-bottom: 8px; /* Reduced margin */
  }
  
  .filter-search-box input {
    width: 100%;
    padding: 6px 8px; /* Tighter padding */
    border: 1px solid #e0e0e0;
    border-radius: 2px;
    font-size: 12px;
  }
  
  .filter-options-list {
    max-height: 200px;
    overflow-y: auto;
    padding: 2px 0; /* Minimal padding */
  }
  
  /* Compact option layout */
  .flipkart-filter-option {
    display: flex;
    align-items: center;
    margin-bottom: 4px; /* Reduced spacing between options */
    padding: 3px 0; /* Tight vertical padding */
    cursor: pointer;
    font-size: 13px;
    color: #212121;
  }
  
  .flipkart-filter-option input[type="checkbox"] {
    width: 14px; /* Slightly smaller checkbox */
    height: 14px;
    margin-right: 6px; /* Reduced gap between checkbox and text */
    accent-color: #2874f0;
    cursor: pointer;
  }
  
  .option-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .no-options {
    font-size: 12px;
    color: #878787;
    padding: 3px 0; /* Tight padding */
    margin: 0;
  }`, "",{"version":3,"sources":["webpack://./src/components/FilterDropdown.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,kBAAkB,EAAE,mBAAmB;IACvC,YAAY,EAAE,oBAAoB;EACpC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,eAAe,EAAE,oBAAoB;IACrC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB,EAAE,mBAAmB;EACzC;;EAEA;IACE,WAAW;IACX,gBAAgB,EAAE,oBAAoB;IACtC,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;EACtC;;EAEA,0BAA0B;EAC1B;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB,EAAE,oCAAoC;IACxD,cAAc,EAAE,2BAA2B;IAC3C,eAAe;IACf,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW,EAAE,8BAA8B;IAC3C,YAAY;IACZ,iBAAiB,EAAE,0CAA0C;IAC7D,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,cAAc,EAAE,kBAAkB;IAClC,SAAS;EACX","sourcesContent":[".flipkart-filter-section {\n    border-bottom: 1px solid #e0e0e0;\n    margin-bottom: 8px; /* Reduced margin */\n    width: 280px; /* Increased width */\n  }\n  \n  .filter-section-header {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 0; /* Reduced padding */\n    font-weight: 500;\n    font-size: 14px;\n    color: #212121;\n    cursor: pointer;\n  }\n  \n  .filter-section-content {\n    padding: 0;\n  }\n  \n  .filter-search-box {\n    margin-bottom: 8px; /* Reduced margin */\n  }\n  \n  .filter-search-box input {\n    width: 100%;\n    padding: 6px 8px; /* Tighter padding */\n    border: 1px solid #e0e0e0;\n    border-radius: 2px;\n    font-size: 12px;\n  }\n  \n  .filter-options-list {\n    max-height: 200px;\n    overflow-y: auto;\n    padding: 2px 0; /* Minimal padding */\n  }\n  \n  /* Compact option layout */\n  .flipkart-filter-option {\n    display: flex;\n    align-items: center;\n    margin-bottom: 4px; /* Reduced spacing between options */\n    padding: 3px 0; /* Tight vertical padding */\n    cursor: pointer;\n    font-size: 13px;\n    color: #212121;\n  }\n  \n  .flipkart-filter-option input[type=\"checkbox\"] {\n    width: 14px; /* Slightly smaller checkbox */\n    height: 14px;\n    margin-right: 6px; /* Reduced gap between checkbox and text */\n    accent-color: #2874f0;\n    cursor: pointer;\n  }\n  \n  .option-name {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .no-options {\n    font-size: 12px;\n    color: #878787;\n    padding: 3px 0; /* Tight padding */\n    margin: 0;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
